import React from 'react';
import { Link } from 'react-router-dom';

// Internal-link helper for the §5 "Politique de confidentialité" mention.
// React-Router <Link> styled like a plain anchor so it blends with the
// surrounding paragraph text.
function PrivacyLink({ children }) {
  return (
    <Link to="/politique-confidentialite" className="ml-link">{children}</Link>
  );
}

// Trophées palette (mêmes valeurs que HomePage / FaqPage)
const NAVY = '#1B1E38';
const CYAN = '#39A8E5';
const BLUE = '#4A71E5';

// Static content extracted from "Mentions Legales IP 2026 V2.docx"
// Each section is rendered with the same visual treatment ; tweaks
// to wording should be done here directly (no DB / no JSON).
const SECTIONS = [
  {
    id: 1,
    title: 'Éditeur de la plateforme',
    body: [
      { label: 'Raison sociale', value: 'Investance Partners' },
      { label: 'Forme juridique', value: 'Société anonyme (SA)' },
      { label: 'Capital social', value: '113 950 euros' },
      { label: 'Siège social', value: '31 rue Saint-Augustin, 75002 Paris' },
      { label: 'RCS', value: 'Paris 435 257 175' },
      { label: 'Numéro de TVA intracommunautaire', value: 'FR23435257175' },
      { label: 'Téléphone', value: '01 40 26 84 40', href: 'tel:+33140268440' },
      { label: 'E-mail', value: 'contact@investance-partners.com', href: 'mailto:contact@investance-partners.com' },
      { label: 'Site internet', value: 'https://isi-app.paradoxe.ai/', href: 'https://isi-app.paradoxe.ai/' },
      { label: 'Directeur de la publication', value: 'Luc-Sorel OM, Directeur Général' },
    ],
  },
  {
    id: 2,
    title: 'Hébergeur de la plateforme',
    paragraphs: [
      <>
        La plateforme Trophées de l'innovation 2026, accessible à l'adresse{' '}
        <a href="https://isi-app.paradoxe.ai/" target="_blank" rel="noopener noreferrer" className="ml-link">https://isi-app.paradoxe.ai/</a>,
        est hébergée par Investance Partners sur sa propre infrastructure, située en France.
        {' '}« Paradoxe.AI » désigne la plateforme propriétaire éditée par Investance Partners ;
        il ne s'agit pas d'un prestataire d'hébergement tiers.
      </>,
    ],
    body: [
      { label: 'Hébergeur', value: 'Investance Partners — Société anonyme au capital de 113 950 euros, RCS Paris 435 257 175.' },
      { label: 'Adresse', value: '31 rue Saint-Augustin, 75002 Paris.' },
      { label: 'Téléphone', value: '01 40 26 84 40', href: 'tel:+33140268440' },
      { label: 'E-mail', value: 'contact@investance-partners.com', href: 'mailto:contact@investance-partners.com' },
    ],
  },
  {
    id: 3,
    title: 'Directeur de la publication',
    paragraphs: [
      <>Le directeur de la publication est <strong>M. Luc-Sorel OM</strong>, Directeur Général d'Investance Partners.</>,
    ],
  },
  {
    id: 4,
    title: 'Propriété intellectuelle',
    paragraphs: [
      <>L'ensemble des contenus présents sur la plateforme (textes, images, logos, données, bases de données, structure du site et de la plateforme) est la propriété exclusive d'Investance Partners ou fait l'objet d'une autorisation d'utilisation, et est protégé par les dispositions du Code de la propriété intellectuelle.</>,
      <>Toute reproduction, représentation, modification, publication, adaptation ou exploitation de tout ou partie des éléments de la plateforme, par quelque procédé que ce soit, est strictement interdite sans l'autorisation écrite préalable d'Investance Partners. Toute exploitation non autorisée constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.</>,
    ],
  },
  {
    id: 5,
    title: 'Données à caractère personnel',
    paragraphs: [
      <>Dans le cadre de l'utilisation de la plateforme, Investance Partners collecte et traite des données à caractère personnel conformément au Règlement (UE) 2016/679 du 27 avril 2016 (RGPD) et à la loi n°78-17 du 6 janvier 1978 modifiée (loi Informatique et Libertés).</>,
    ],
    body: [
      { label: 'Responsable de traitement', value: 'Investance Partners, 31 rue Saint-Augustin, 75002 Paris.' },
      { label: 'Référente RGPD', value: 'rgpd@investance-partners.com', href: 'mailto:rgpd@investance-partners.com' },
    ],
    afterParagraphs: [
      <>Les Utilisateurs disposent d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de leurs données personnelles. Ces droits peuvent être exercés en contactant directement la référente RGPD.</>,
      <>
        Pour toute réclamation relative au traitement de vos données, vous pouvez saisir la Commission Nationale de l'Informatique et des Libertés (CNIL) :{' '}
        <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="ml-link">www.cnil.fr</a>.
      </>,
      <>Les modalités détaillées du traitement de vos données figurent dans la <PrivacyLink>Politique de confidentialité</PrivacyLink> accessible sur la plateforme.</>,
    ],
  },
  {
    id: 6,
    title: 'Cookies',
    paragraphs: [
      <>La plateforme <strong>ne dépose aucun cookie</strong> sur le terminal de l'Utilisateur. Aucun bandeau de consentement n'est requis. Les mécanismes de stockage local utilisés à des fins strictement fonctionnelles ainsi que les ressources tierces éventuellement chargées par le navigateur sont décrits dans la politique de confidentialité accessible sur la plateforme.</>,
    ],
  },
  {
    id: 7,
    title: 'Liens hypertextes',
    paragraphs: [
      <>La plateforme peut contenir des liens vers des sites internet de partenaires ou de tiers. Investance Partners n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu, leurs pratiques en matière de données personnelles ou leur disponibilité.</>,
      <>
        Tout site souhaitant établir un lien hypertexte vers la plateforme doit préalablement obtenir l'autorisation écrite d'Investance Partners à l'adresse{' '}
        <a href="mailto:contact@investance-partners.com" className="ml-link">contact@investance-partners.com</a>.
      </>,
    ],
  },
  {
    id: 8,
    title: 'Limitation de responsabilité',
    paragraphs: [
      <>Investance Partners s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur la plateforme. Toutefois, Investance Partners ne peut garantir l'exactitude, la complétude ou l'actualité de ces informations et décline toute responsabilité pour les dommages résultant de leur utilisation.</>,
      <>Investance Partners ne saurait être tenu responsable des dommages directs ou indirects résultant de l'accès à la plateforme, de son utilisation ou de son indisponibilité temporaire, sauf en cas de faute lourde ou dolosive de sa part.</>,
    ],
  },
  {
    id: 9,
    title: 'Médiation commerciale',
    paragraphs: [
      <>En cas de litige relatif à l'utilisation de la plateforme ou au processus des Trophées de l'innovation 2026, les parties s'engagent à tenter de trouver une solution amiable dans un délai de trente (30) jours.</>,
      <>
        À défaut, et sans préjudice de tout recours judiciaire, les parties peuvent recourir aux dispositifs de médiation suivants : lorsque le litige oppose Investance Partners à un Utilisateur agissant en qualité de personne morale, au Centre de Médiation et d'Arbitrage de Paris (CMAP —{' '}
        <a href="https://www.cmap.fr" target="_blank" rel="noopener noreferrer" className="ml-link">www.cmap.fr</a>).
      </>,
    ],
  },
  {
    id: 10,
    title: 'Droit applicable',
    paragraphs: [
      <>Les présentes mentions légales sont régies par le droit français. En cas de litige relatif à leur interprétation ou à leur exécution, les tribunaux de Paris seront seuls compétents.</>,
    ],
  },
];

const EFFECTIVE_DATE = '20/05/2026';
const LAST_UPDATE = '20/05/2026';

export default function MentionsLegalesPage() {
  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      {/* ===== Top bar : same shell as the landing page ===== */}
      <header
        style={{
          background: NAVY, color: 'white', padding: '14px 32px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          position: 'sticky', top: 0, zIndex: 100,
        }}
      >
        <Link to="/" style={{ display: 'flex', alignItems: 'baseline', gap: 8, textDecoration: 'none', color: 'white' }}>
          <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 800, fontSize: 18, letterSpacing: '-0.3px' }}>
            Plateforme ISI
          </span>
          <span style={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: 13, color: CYAN }}>
            by Paradoxe.ai for LBP AM
          </span>
        </Link>
        <nav style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <Link to="/faq" style={navLinkStyle}>FAQ</Link>
          <a href="mailto:contact.tropheeslbpam@investance-partners.com" style={navLinkStyle}>Nous contacter</a>
          <Link to="/login" style={navLinkStyle}>Se connecter</Link>
          <Link to="/register" style={{ ...navLinkStyle, color: 'white', background: BLUE, border: `1px solid ${BLUE}` }}>Créer un compte</Link>
        </nav>
      </header>

      {/* ===== Hero ===== */}
      <section style={{
        background: `linear-gradient(180deg, ${NAVY} 0%, #2A2E4E 100%)`,
        color: 'white', padding: '56px 32px 40px',
      }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <p style={{ fontSize: 13, color: CYAN, fontWeight: 600, letterSpacing: 1.2, marginBottom: 12, textTransform: 'uppercase' }}>
            Informations légales
          </p>
          <h1 style={{ fontFamily: 'Lato, sans-serif', fontSize: 38, fontWeight: 800, lineHeight: 1.15, marginBottom: 12, marginTop: 0 }}>
            Mentions légales
          </h1>
          <p style={{ fontSize: 16, lineHeight: 1.55, color: 'rgba(255,255,255,0.85)', maxWidth: 720, marginBottom: 0 }}>
            Plateforme Trophées de l'innovation 2026
            <br />
            <span style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.65)' }}>
              Conformément aux articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN).
            </span>
          </p>
        </div>
      </section>

      {/* ===== Body ===== */}
      <section style={{ padding: '48px 32px 64px', background: '#FAFBFD' }}>
        <div style={{ maxWidth: 880, margin: '0 auto' }}>
          {SECTIONS.map((sec) => (
            <article key={sec.id} style={{
              background: 'white', borderRadius: 14,
              padding: '28px 32px', marginBottom: 18,
              boxShadow: '0 1px 3px rgba(27,30,56,0.06), 0 0 0 1px rgba(27,30,56,0.04)',
            }}>
              <h2 style={{
                fontFamily: 'Lato, sans-serif', fontSize: 20, fontWeight: 700,
                color: NAVY, marginTop: 0, marginBottom: 16,
                display: 'flex', alignItems: 'baseline', gap: 10,
              }}>
                <span style={{
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  width: 28, height: 28, borderRadius: '50%',
                  background: BLUE, color: 'white', fontSize: 13, fontWeight: 700,
                  flexShrink: 0,
                }}>
                  {sec.id}
                </span>
                {sec.title}
              </h2>

              {sec.paragraphs && sec.paragraphs.map((p, i) => (
                <p key={`p-${i}`} style={paragraphStyle}>{p}</p>
              ))}

              {sec.body && (
                <dl style={{ margin: '8px 0', display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8px 18px', alignItems: 'baseline' }}>
                  {sec.body.map((row, i) => (
                    <React.Fragment key={`b-${i}`}>
                      <dt style={{ fontWeight: 600, color: NAVY, fontSize: 14, whiteSpace: 'nowrap' }}>{row.label} :</dt>
                      <dd style={{ margin: 0, color: '#444', fontSize: 14 }}>
                        {row.href ? (
                          <a href={row.href} className="ml-link"
                             {...(row.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                            {row.value}
                          </a>
                        ) : row.value}
                      </dd>
                    </React.Fragment>
                  ))}
                </dl>
              )}

              {sec.afterParagraphs && sec.afterParagraphs.map((p, i) => (
                <p key={`a-${i}`} style={paragraphStyle}>{p}</p>
              ))}
            </article>
          ))}

          {/* Effective + last-update line */}
          <div style={{
            marginTop: 28, padding: '20px 24px', borderRadius: 10,
            background: 'white',
            border: '1px solid #E3E7F2',
            color: '#555', fontSize: 13.5, lineHeight: 1.7,
            textAlign: 'center',
          }}>
            <div>Mentions légales mises en vigueur le : <strong style={{ color: NAVY }}>{EFFECTIVE_DATE}</strong></div>
            <div>Dernière mise à jour : <strong style={{ color: NAVY }}>{LAST_UPDATE}</strong></div>
            <div style={{ marginTop: 10, fontSize: 12, color: '#888' }}>
              Investance Partners — 31 rue Saint-Augustin, 75002 Paris — RCS Paris 435 257 175
            </div>
          </div>

          {/* Back-to-home CTA + lateral nav between legal pages */}
          <div style={{ marginTop: 32, textAlign: 'center', display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" style={{
              display: 'inline-block', padding: '10px 24px',
              border: `1px solid ${BLUE}`, color: BLUE,
              borderRadius: 999, textDecoration: 'none',
              fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: 14,
            }}>← Retour à l'accueil</Link>
            <Link to="/politique-confidentialite" style={{
              display: 'inline-block', padding: '10px 24px',
              border: `1px solid ${NAVY}`, color: NAVY,
              borderRadius: 999, textDecoration: 'none',
              fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: 14,
            }}>Politique de confidentialité</Link>
            <Link to="/cgu" style={{
              display: 'inline-block', padding: '10px 24px',
              border: `1px solid ${NAVY}`, color: NAVY,
              borderRadius: 999, textDecoration: 'none',
              fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: 14,
            }}>CGU</Link>
            <Link to="/reglement" style={{
              display: 'inline-block', padding: '10px 24px',
              border: `1px solid ${NAVY}`, color: NAVY,
              borderRadius: 999, textDecoration: 'none',
              fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: 14,
            }}>Règlement des trophées de l'innovation 2026</Link>
          </div>
        </div>
      </section>

      {/* Inline styles for the ml-link class (mirrors lp-inline-link) */}
      <style>{`
        .ml-link {
          color: ${BLUE};
          text-decoration: none;
          border-bottom: 1px solid transparent;
          transition: color 0.15s, border-color 0.15s;
          word-break: break-word;
        }
        .ml-link:hover { color: ${CYAN}; border-bottom-color: ${CYAN}; }
        .ml-link:focus-visible {
          outline: 2px solid ${CYAN};
          outline-offset: 2px;
          border-radius: 2px;
        }
      `}</style>
    </div>
  );
}

const navLinkStyle = {
  fontFamily: 'Lato, sans-serif', fontSize: 14, fontWeight: 600,
  padding: '9px 18px', borderRadius: 999, textDecoration: 'none',
  color: 'rgba(255,255,255,0.85)', whiteSpace: 'nowrap',
};

const paragraphStyle = {
  fontSize: 14.5, lineHeight: 1.7, color: '#333',
  margin: '0 0 12px',
};
